import { css } from "@emotion/css";
import { theme } from "assets/theme";
import { WarningPlainIcon } from "components/icons";
import React from "react";
import { Text } from "../text";

type Props = {
  text: string;
  actionText?: string;
  onAction?: () => void;
  variant: "info" | "warning" | "error";
};

export const AlertCard: React.FC<Props> = ({
  text,
  actionText,
  onAction,
  variant,
}) => {
  const getVariantColor = () => {
    switch (variant) {
      case "info":
        return theme.colors.accent["purple/dark"];
      case "warning":
        return theme.colors.accent["yellow/main"];
      case "error":
        return theme.colors.accent["red/main"];
    }
  };

  return (
    <div
      className={css`
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        background-color: #161617;
        border-radius: 12px;
      `}
    >
      <WarningPlainIcon
        style={{ marginRight: "16px", width: "32px", height: "32px" }}
        fill={
          variant === "info"
            ? "primary"
            : variant === "error"
              ? "danger"
              : "warning"
        }
      />
      <Text.BodyXS
        color={
          variant === "info"
            ? "primary"
            : variant === "error"
              ? "danger"
              : "warning"
        }
      >
        {text}
      </Text.BodyXS>
      {actionText && (
        <button
          onClick={onAction}
          className={css`
            height: 32px;
            padding: 0 16px;
            border: none;
            background-color: ${theme.colors.accent.white};
            color: ${getVariantColor()};
            border-radius: 8px;
            cursor: pointer;
          `}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};
